import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'assets/icons';
import { getWelcomeForTrack } from 'app/member/guides/welcome';
import { SlideshowModal } from '../slideshow';
import styles from './welcome.module.css';

export const Welcome = () => {
  const track = useSelector((state) => state.metadata.agency?.track);
  const [show, setShow] = useState(false);

  const slides = getWelcomeForTrack(track);
  const thumbnail = slides[0]?.image;

  if (!thumbnail) return null;

  return (
    <div className={styles.wrapper}>
      <button type="button" className={styles.card} onClick={() => setShow(true)}>
        <img src={thumbnail} alt="" className={styles.thumbnail} />
        <span className={styles.overlay}>
          <span className={styles.badge}>
            <Icon name="expand" width={16} height={16} />
            <span>Quick start</span>
          </span>
        </span>
      </button>

      <SlideshowModal slides={slides} framed={false} show={show} onClose={() => setShow(false)} />
    </div>
  );
};
